module.exports = __webpack_public_path__ + "img/de.12411997.png";